export function initDataNumbers() {
    const counters = document.querySelectorAll<HTMLElement>('[data-number]');
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const counter = entry.target as HTMLElement;
                const target = parseFloat(counter.dataset.number!);
                const hasDecimals = target % 1 !== 0;
                const duration = 2000; // 2 seconds
                const step = target / (duration / 16); // 60fps
                let current = 0;

                const timer = setInterval(() => {
                    current += step;
                    if (current >= target) {
                        current = target;
                        clearInterval(timer);
                    }
                    // Match the server's en-GB formatting (4,500) so the final value is unchanged.
                    counter.textContent = hasDecimals
                        ? current.toLocaleString('en-GB', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
                        : Math.floor(current).toLocaleString('en-GB');
                }, 16);

                observer.unobserve(counter);
            }
        });
    });

    counters.forEach(counter => observer.observe(counter));
}